import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Modal,
  RadioGroup,
  Select,
  TextField,
} from "@mui/material";
import React from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  // addAnalysisAndGraphs,
  setIsLoading,
} from "../../../features/datatable/dataTableSlice";

import { createAnalysis } from "../../../utils/computation/analysis";
import { getColumnValues } from "../../../utils/computation/getColumnValues";
import { getGraphicalSummary } from "../../../utils/computation/getGraphicalSummary";
import Dropdown from "../../Dropdown";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  bgcolor: "background.paper",
  p: 4,
  borderRadius: "15px",
};

function GraphicalSummaryModal({ title, closeMenu, openModal, setOpenModal }) {
  //local states

  const [confidenceLevel, setConfidenceLevel] = useState(0);
  const [sigLevel, setsigLevel] = useState(95);
  const [bootstrapSample, setbootstrapSample] = useState(0);
  const [selectedColumn, setSelectedColumn] = useState("");

  //functions
  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    closeMenu();
    setOpenModal(false);
  };

  const handleChangeConfidence = (confidence) => {
    setConfidenceLevel(confidence);
  };
  const handleChangeSigLevel = (val) => {
    setsigLevel(val);
  };
  const handleChangeBootStrap = (val) => {
    setbootstrapSample(val);
  };
  const handleChangeColumn = (col) => {
    setSelectedColumn(col);
  };

  //redux states
  const { token } = useSelector((state) => state.auth);
  const { data } = useSelector((state) => state.dataTable);

  //params
  const { documentId } = useParams();

  //dispatch
  const dispatch = useDispatch();

  const createGraph = async () => {
    dispatch(setIsLoading());
    // get the array value of selected column
    const value = getColumnValues(data, selectedColumn);
    let level = confidenceLevel / 100;
    if (value.length > 0) {
      closeMenu();
      // console.log("value", value);
      // return console.log("confidenceLevel", confidenceLevel);
      let results = await getGraphicalSummary({
        value: value,
        confidenceLevel: level,
        sigLevel: 0.05,
        bootstrap_sample: 10000,
      });

      //populate analysis object
      const graphicalSummaryResult = {
        ...results,
        column: selectedColumn,
        title,
      };

      try {
        const resFromCreateAnalysis = await createAnalysis(
          token,
          documentId,
          graphicalSummaryResult
        );
        graphicalSummaryResult.id = resFromCreateAnalysis.id;
      } catch (error) {
        return console.log("error", error);
      }

      // dispatch(addAnalysisAndGraphs(graphicalSummaryResult)); // add dispatch here;
      dispatch(setIsLoading());
      //update user document
    } else {
      closeMenu();
      dispatch(setIsLoading());
    }
  };

  return (
    <Modal
      open={openModal === title}
      onClose={handleCloseModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <h1> Graphical Summary</h1>
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={6} p={1}>
            <h3> Data Range</h3>
            <h3
              style={{
                marginTop: "10px",
              }}
            >
              Select a column for the test
            </h3>
            <FormControl variant="filled" fullWidth sx={{ mt: 1 }}>
              <InputLabel id="demo-simple-select-label">Column</InputLabel>
              <Dropdown
                value={selectedColumn}
                onChange={(e) => handleChangeColumn(e.target.value)}
              />
            </FormControl>
          </Grid>
          <Grid item xs={6} p={1}>
            <h3> Additional Options</h3>
            <h3
              style={{
                marginTop: "10px",
              }}
            >
              Confidence level
            </h3>
            <TextField
              fullWidth
              id="filled-basic"
              variant="filled"
              label="level"
              sx={{ mt: 1 }}
              defaultValue={95}
              onChange={(e) => handleChangeConfidence(e.target.value)}
            />
            <h3
              style={{
                marginTop: "10px",
              }}
            >
              Sig level
            </h3>
            <TextField
              fullWidth
              id="filled-basic"
              variant="filled"
              label="Sig evel"
              sx={{ mt: 1 }}
              defaultValue={0}
              onChange={(e) => handleChangeSigLevel(e.target.value)}
            />
            <h3
              style={{
                marginTop: "10px",
              }}
            >
              Bootstrap sample
            </h3>
            <TextField
              fullWidth
              id="filled-basic"
              variant="filled"
              label="bootstrap sample"
              sx={{ mt: 1 }}
              defaultValue={0}
              onChange={(e) => handleChangeBootStrap(e.target.value)}
            />
          </Grid>
        </Grid>
        <div style={{ display: "flex", float: "right", marginTop: "20px" }}>
          <Button
            variant="outlined"
            style={{
              borderRadius: "15px",
            }}
            onClick={handleCloseModal}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            style={{
              width: "auto",
              marginLeft: "10px",
            }}
            onClick={() => createGraph()}
          >
            Run Function
          </Button>
        </div>
      </Box>
    </Modal>
  );
}

export default GraphicalSummaryModal;
